import { http, ep } from "../../client/http";

export const stockRepo = {
  getSafkar: async () => {
    const res = await http.get(ep("stock/safkar"));
    return res.data.data; // backend'de "data: json.chart.result[0]" döndürmüştük
  },
};
